import { useEffect } from 'react';
import type React from 'react';

export const useOnMount = (factory: React.EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(factory, []);
};
